const setHeaderTitle = (title: string): void => {
    const feedHeaderTitle = document.getElementById('feedHeaderTitle');

    if (feedHeaderTitle) {
        feedHeaderTitle.textContent = title;
    }
};

export default setHeaderTitle;
